module.exports = __webpack_public_path__ + "img/05-innovation-technology.26929373.jpg";